import { ApiCacheTags, baseApiService } from '@qapline/api';
import { getConfig } from '@qapline/config';

import { TListCountriesResponseBody } from '../types';

const { list: listEndpoint } = getConfig().api.endpoints.country;
const { list: listTag } = ApiCacheTags.country;

export const countryApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        listCountries: builder.query<TListCountriesResponseBody, void>({
            query() {
                return {
                    url: listEndpoint,
                    method: 'GET',
                };
            },
            providesTags: () => [{ type: listTag }],
        }),
    }),
});

export const { useLazyListCountriesQuery, useListCountriesQuery } = countryApi;
